import { combineReducers } from 'redux';
import general from './general';
import shipstation from './shipstation';
import zendesk from './zendesk';
import ticketSearch from './ticketSearch';
import ordersSearch from './ordersSearch';
import subscriptionSearch from './subscriptionSearch';
import macroWizard from './macroWizard';
import commerceWizard from './commerceWizard';
import subscriptionOrders from './subscriptionOrders';
import businessAlerts from './businessAlerts';
import alertsManager from './alertsManager';
import address from './address';
import decisionTree from './decisionTree/index';
import returnsSearch from './returnsSearch';
import customerSearch from './customerSearch';
import accountSearch from './accountSearch';
import customerDetails from './customerDetails';
import rbi from './rbi';

export default combineReducers({
  general,
  zendesk,
  ticketSearch,
  ordersSearch,
  subscriptionSearch,
  shipstation,
  macroWizard,
  commerceWizard,
  subscriptionOrders,
  businessAlerts,
  alertsManager,
  address,
  decisionTree,
  returnsSearch,
  customerSearch,
  accountSearch,
  customerDetails,
  rbi,
});
